"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RoleSwitchModal_styled_exports = {};
__export(RoleSwitchModal_styled_exports, {
  HeadingRolePickerItem: () => HeadingRolePickerItem,
  StyledArrowWrapper: () => StyledArrowWrapper,
  StyledAvatar: () => StyledAvatar,
  StyledEmail: () => StyledEmail,
  StyledGlobalModal: () => StyledGlobalModal,
  StyledHeaderWrapper: () => StyledHeaderWrapper,
  StyledHeading: () => StyledHeading,
  StyledIcon: () => StyledIcon,
  StyledLoaderRole: () => StyledLoaderRole,
  StyledLoaderRoleWrapper: () => StyledLoaderRoleWrapper,
  StyledLoaderTitle: () => StyledLoaderTitle,
  StyledLoaderWrapper: () => StyledLoaderWrapper,
  StyledMobileRoleSwitchPopupContainer: () => StyledMobileRoleSwitchPopupContainer,
  StyledModalContentWrapper: () => StyledModalContentWrapper,
  StyledRoleSwitchButton: () => StyledRoleSwitchButton,
  StyledRoleSwitchMobileContainer: () => StyledRoleSwitchMobileContainer,
  StyledRoleSwitchModalContainer: () => StyledRoleSwitchModalContainer,
  StyledSquareLoader: () => StyledSquareLoader,
  StyledSwitchRoleTitle: () => StyledSwitchRoleTitle
});
module.exports = __toCommonJS(RoleSwitchModal_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Button = require("../../atoms/Button/Button.component");
var import_mixins = require("../../../themes/mixins");
var import_Avatar = require("../../atoms/Avatar/Avatar.component");
var import_Heading = require("../../atoms/Heading/Heading.component");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_GlobalModal = require("../GlobalModal/GlobalModal.component");
var StyledAvatar = (0, import_styled_components.default)(import_Avatar.Avatar).withConfig({
  displayName: "RoleSwitchModalstyled__StyledAvatar",
  componentId: "sc-wiadl9-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["line-height:", ";"], theme.typography.sizes.large);
});
var StyledHeaderWrapper = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledHeaderWrapper",
  componentId: "sc-wiadl9-1"
})(function() {
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;align-items:center;"]);
});
var StyledHeading = (0, import_styled_components.default)(import_Heading.Heading).withConfig({
  displayName: "RoleSwitchModalstyled__StyledHeading",
  componentId: "sc-wiadl9-2"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["color:", ";margin:12px 0 0;padding:0px;"], theme.colors.n["100"]);
});
var StyledEmail = import_styled_components.default.h2.withConfig({
  displayName: "RoleSwitchModalstyled__StyledEmail",
  componentId: "sc-wiadl9-3"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["color:", ";font-family:", ";font-size:", ";font-weight:", ";margin-top:8px;margin-bottom:0;"], theme.colors.n["60"], theme.typography.fonts.primary, theme.typography.sizes.medium, theme.typography.weights.regular);
});
var StyledSwitchRoleTitle = import_styled_components.default.p.withConfig({
  displayName: "RoleSwitchModalstyled__StyledSwitchRoleTitle",
  componentId: "sc-wiadl9-4"
})(function(_ref4) {
  var theme = _ref4.theme, currentRole = _ref4.currentRole;
  return (0, import_styled_components.css)(["text-align:center;font-family:", ";font-size:", ";font-weight:", ";margin-top:", ";margin-bottom:10px;"], theme.typography.fonts.primary, theme.typography.sizes.medium, theme.typography.weights.black, currentRole ? "28px" : "32px");
});
var HeadingRolePickerItem = import_styled_components.default.h2.withConfig({
  displayName: "RoleSwitchModalstyled__HeadingRolePickerItem",
  componentId: "sc-wiadl9-5"
})(function() {
  return (0, import_styled_components.css)(["font-size:normal;margin-block-start:0px;margin-block-end:0px;"]);
});
var StyledModalContentWrapper = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledModalContentWrapper",
  componentId: "sc-wiadl9-6"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:20px;"]);
var StyledRoleSwitchButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "RoleSwitchModalstyled__StyledRoleSwitchButton",
  componentId: "sc-wiadl9-7"
})(function(_ref5) {
  var theme = _ref5.theme;
  return (0, import_styled_components.css)(["", " width:240px;height:40px;justify-content:center;span{font-size:", ";color:", ";justify-content:center;height:24px;}i{color:", ";transform:rotate(45deg);margin-right:3px;}"], (0, import_mixins.withPadding)("medium"), theme.typography.sizes.small, theme.colors.n[100], theme.colors.pr.base);
});
var StyledLoaderWrapper = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledLoaderWrapper",
  componentId: "sc-wiadl9-8"
})(function(_ref6) {
  var customWidth = _ref6.customWidth, customHeight = _ref6.customHeight;
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;align-items:center;width:100%;margin-top:65px;min-height:", ";", ""], customHeight, (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:", ";margin:48px 0px;"], customWidth)));
});
var StyledSquareLoader = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledSquareLoader",
  componentId: "sc-wiadl9-9"
})(["> div{position:relative;z-index:0;width:64px;height:64px;overflow:hidden;padding:2rem;}> div::before{content:'';position:absolute;z-index:-2;left:-50%;top:-50%;width:200%;height:200%;background-repeat:no-repeat;background-size:50% 50%,50% 50%;background-position:0 0,100% 0,100% 100%,0 100%;background-image:linear-gradient(#000000,#000000),linear-gradient(#000000,#000000),linear-gradient(#000000,#000000),linear-gradient(#ffffff,#ffffff);animation:rotate 2s linear infinite;}@keyframes rotate{100%{transform:rotate(1turn);}}> div::after{content:'';position:absolute;z-index:-1;left:4px;top:4px;width:calc(100% - 8px);height:calc(100% - 8px);background:white;}*,*::before,*::after{box-sizing:border-box;}"]);
var StyledLoaderTitle = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledLoaderTitle",
  componentId: "sc-wiadl9-10"
})(function(_ref7) {
  var theme = _ref7.theme;
  return (0, import_styled_components.css)(["font-weight:", ";font-size:", ";margin:24px 0 26px 0;"], theme.typography.weights.black, theme.typography.sizes.extraLarge);
});
var StyledLoaderRoleWrapper = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledLoaderRoleWrapper",
  componentId: "sc-wiadl9-11"
})(function() {
  return (0, import_styled_components.css)(["display:flex;height:40px;align-items:center;justify-content:center;"]);
});
var StyledGlobalModal = (0, import_styled_components.default)(import_GlobalModal.GlobalModal).withConfig({
  displayName: "RoleSwitchModalstyled__StyledGlobalModal",
  componentId: "sc-wiadl9-12"
})(function(_ref8) {
  var withKebabMenu = _ref8.withKebabMenu;
  return (0, import_styled_components.css)(["display:", ";max-height:90vh;", ""], withKebabMenu ? "none" : "block", (0, import_mixins.mediaBreakpointUp)("md", "\n       display: block;\n    "));
});
var StyledRoleSwitchModalContainer = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledRoleSwitchModalContainer",
  componentId: "sc-wiadl9-13"
})(function(_ref9) {
  var withKebabMenu = _ref9.withKebabMenu;
  return (0, import_styled_components.css)(["display:", ";", ""], withKebabMenu ? "none" : "block", (0, import_mixins.mediaBreakpointUp)("md", "\n       display: block;\n    "));
});
var StyledRoleSwitchMobileContainer = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledRoleSwitchMobileContainer",
  componentId: "sc-wiadl9-14"
})(function() {
  return (0, import_styled_components.css)(["display:block;", ""], (0, import_mixins.mediaBreakpointUp)("md", "\n       max-height: 90vh;\n       display: none;\n    "));
});
var StyledMobileRoleSwitchPopupContainer = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledMobileRoleSwitchPopupContainer",
  componentId: "sc-wiadl9-15"
})(function(_ref10) {
  var theme = _ref10.theme;
  return (0, import_styled_components.css)(["display:block;position:fixed;top:0;left:0;width:100%;height:100%;z-index:1002;background-color:", ";overflow-y:auto;", ""], theme.colors.white, (0, import_mixins.mediaBreakpointUp)("md", "\n       display: none;\n    "));
});
var StyledLoaderRole = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledLoaderRole",
  componentId: "sc-wiadl9-16"
})(function(_ref11) {
  var theme = _ref11.theme;
  return (0, import_styled_components.css)(["display:flex;align-items:center;text-align:center;font-weight:", ";p{max-width:106px;line-height:1.25rem;font-size:", ";color:", ";text-align:left;margin:0;}> i{color:", ";}"], theme.typography.weights.black, theme.typography.sizes.medium, theme.colors.n[60], theme.colors.n[60]);
});
var StyledIcon = (0, import_styled_components.default)(import_Icon.Icon).withConfig({
  displayName: "RoleSwitchModalstyled__StyledIcon",
  componentId: "sc-wiadl9-17"
})(function() {
  return (0, import_styled_components.css)(["&&{letter-spacing:0px;margin-right:10px;}"]);
});
var StyledArrowWrapper = import_styled_components.default.div.withConfig({
  displayName: "RoleSwitchModalstyled__StyledArrowWrapper",
  componentId: "sc-wiadl9-18"
})(function() {
  return (0, import_styled_components.css)(["&&{display:flex;justify-content:center;align-items:center;width:40px;height:40px;i{margin:0;}}"]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  HeadingRolePickerItem,
  StyledArrowWrapper,
  StyledAvatar,
  StyledEmail,
  StyledGlobalModal,
  StyledHeaderWrapper,
  StyledHeading,
  StyledIcon,
  StyledLoaderRole,
  StyledLoaderRoleWrapper,
  StyledLoaderTitle,
  StyledLoaderWrapper,
  StyledMobileRoleSwitchPopupContainer,
  StyledModalContentWrapper,
  StyledRoleSwitchButton,
  StyledRoleSwitchMobileContainer,
  StyledRoleSwitchModalContainer,
  StyledSquareLoader,
  StyledSwitchRoleTitle
});
//# sourceMappingURL=RoleSwitchModal.styled.js.map